
<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>حذف حساب کاربری </h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>

			<div class="card card-style mb-3">
				<div class="content pb-2">
					<div class="text-center mb-3">
						<i class="fa fa-exclamation-triangle text-warning fa-3x pt-3 icon-size"></i>
					</div>
					<p class="text-justify mb-0">
						شما در حال انجام عملیات
						<b class="text-danger">حذف حساب کاربری</b>
						خود هستید. لطفاً توجه داشته باشید که این اقدام
						<b class="text-danger">غیرقابل بازگشت</b>
						است و تمام اطلاعات مرتبط با حساب کاربری شما برای همیشه حذف خواهند شد.
					</p>
					<p class="text-justify mb-0">
						پس از حذف، امکان بازیابی حساب وجود ندارد.
					</p>
					<p class="text-justify mb-0">
						اشتراک پرداخت شده قابل بازگشت و انتقال به کاربر دیگر نمی باشد.
					</p>
				</div>
			</div>

			<div class="card card-style">
				<div class="content">
					<div class="d-flex">
						<div class="align-self-center">
							<a href="#" class="icon icon-l brand-bg-color color-white rounded-m ml-3"><i class="fa fa-user"></i></a>
						</div>
						<div class="align-self-center">
							<h4 class="font-600 m-0 font-18">اطلاعات حساب کاربری</h4>
						</div>
					</div>
					<div class="divider mt-3 mb-2"></div>
					<div class="row mb-0">
						<div class="col-5 pl-0"><p class="font-13">نام کاربر:</p></div>
						<div class="col-7"><p class="font-13 font-700">{{user.title}}</p></div>
						<div class="divider divider-margins w-100 mt-2 mb-2"></div>
						<div class="col-5 pl-0"><p class="font-13">شماره تلفن همراه:</p></div>
						<div class="col-7"><p class="font-13 font-700">{{user.phoneNumber}}</p></div>
						<div class="divider divider-margins w-100 mt-2 mb-2"></div>
						<div class="col-5 pl-0"><p class="font-13">ایمیل:</p></div>
						<div class="col-7"><p class="font-13 font-700">{{user.emailAddress}}</p></div>
						<div class="divider divider-margins w-100 mt-2 mb-2"></div>
						<div class="col-5 pl-0"><p class="font-13">روش ثبت نام:</p></div>
						<div class="col-7" v-if="user.registByEmail"><p class="font-13 font-700">با ایمیل</p></div>
						<div class="col-7" v-else><p class="font-13 font-700">با شماره تلفن همراه</p></div>
						<div class="divider divider-margins w-100 mt-2 mb-2"></div>
						<div class="col-5 pl-0"><p class="font-13">کد احراز هویت:</p></div>
						<div class="col-12">
							<button type="button" class="mt-3 btn btn-xxs btn-full rounded-sm bg-green2-light font-900 w-100" @click="ShowAutdenticationCode()">
								<i class="fa fa-check ml-2"></i>
								کد احراز هویت دارم
							</button>
							<button type="button" class="mt-3 btn btn-xxs btn-full rounded-sm bg-warning text-white font-900 w-100" @click="ShowDonotHaveAutdenticationCode()">
								<i class="fa fa-envelope ml-2"></i>
								کد احراز هویت ندارم
							</button>
						</div>
					</div>

					<div class="mt-3 d-none" id="haveAutdenticationCode">
						<p class="mb-2">کد احراز هویت را وارد کنید:</p>
						<input class="form-control" type="text" v-model="verifyCode" maxlengtd="200">
						<button type="button" class="mt-3 btn btn-xxs btn-full rounded-sm bg-red1-light font-900 w-100" @click="DeleteUserByAutdenticationCode()">
							<i class="fa fa-trash ml-2"></i>
							حذف حساب کاربری
						</button>
					</div>
					<div class="mt-3 d-none" id="donotHaveAutdenticationCode">
						<div class="display-flex justify-content-between">
							<p class="mb-2">دلیل حذف حساب کاربری را وارد کنید:</p>
							<textarea class="form-control" rows="4" v-model="reason" maxlengtd="200"></textarea>
							<button type="button" class="mt-3 btn btn-xxs btn-full rounded-sm bg-highlight font-900 w-100" @click="GetAutdenticationCode()">
								<i class="fa fa-envelope ml-2"></i>
								دریافت کد احراز هویت
							</button>
						</div>
						<p class="text-justify mb-0 mt-3">
							<i class="fa fa-question-circle text-danger Flip-h ml-2"></i>
							پس از دریافت کد احراز هویت، گزینه
							<b>کد احراز هویت دارم</b>
							را انتخاب و کد
							دریافت شده را وارد و روی دکمه حذف حساب کاربری کلیک کنید.
						</p>

					</div>
				</div>

				<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
					<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
						<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		required
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';
	import { maska } from 'maska'

	import VueSimpleAlert from 'vue3-simple-alert';

	export default {
		data() {
			return {
				pageLoading: false,
				reason: "",
				verifyCode: "",
				userCode: "",

				user: {
					adminPage: false,
					userCode: "",
					title: "",
					phoneNumber: "",
					emailAddress: "",
					registByEmail: false,
				}

			}
		},
		created() {
			this.userCode = this.$route.params.code;
			this.GetUserItem();
		},
		methods: {
			ShowDonotHaveAutdenticationCode() {
				document.getElementById("donotHaveAutdenticationCode").classList.remove("d-none");
				document.getElementById("haveAutdenticationCode").classList.add("d-none");
			},
			ShowAutdenticationCode() {
				document.getElementById("haveAutdenticationCode").classList.remove("d-none");
				document.getElementById("donotHaveAutdenticationCode").classList.add("d-none");
			},
			DeleteUserByAutdenticationCode() {
				if (this.user.userCode == null || this.user.userCode == "") {
					this.showErrorMessage("اطلاعات ارسالی معتبر نیست");
					return;
				}
				var obj = {
					registByEmail: false,
					userCode: this.user.userCode,
					verifyCode: this.verifyCode
				};
				this.pageLoading = true;
				this.$http.post("TaskOnline/DeleteUserByAuthenticationCode", obj)
					.then(data => {
						this.pageLoading = false;
						var res = data.data;
						if (res.isSuccess) {
							this.showSuccessMessage("حساب کاربری حذف شد.");
							if (!this.user.adminPage) {
								this.$store.dispatch("SignOutUser");
							}
						} else {
							this.showErrorMessage(res.message);
						}
					});

			},
			GetAutdenticationCode() {
				if (this.reason.lengtd < 10) {
					this.showErrorMessage("دلیل حذف باید بیشتر از 10 کاراکتر باشد.");
					return;
				}
				if (this.reason.lengtd > 200) {
					this.showErrorMessage("دلیل حذف نمیتواند بیشتر از 200 کاراکتر باشد.");
					return;
				}
				if (this.user.userCode == null || this.user.userCode == "") {
					this.showErrorMessage("اطلاعات ارسالی معتبر نیست");
					return;
				}
				let obj = {
					registByEmail: false,
					userCode: this.user.userCode,
					reason: this.reason
				};
				this.pageLoading = true;
				this.$http.post("TaskOnline/GetAuthenticationCode", obj)
					.then(data => {
						this.pageLoading = false;
						var res = data.data;
						if (res.isSuccess) {
							this.showSuccessMessage("کد احراز هویت برای کاربر مورد نظر ارسال شد");
							this.ShowAutdenticationCode();
						} else {
							this.showErrorMessage(res.message);
						}
					});
			},
			GetUserItem() {
				this.$http.get("TaskOnline/GetUserTaskOnlineForDelete?userCode=" + this.userCode).then((data) => {
					this.user = data.data;
				});
			}
		},

		mounted() {
			this.pageLoading = false;

		}
	}
</script>